export enum EnumRoutePaths {
  HOME = '/home',
  DEFAULT = '/',
  NO_MATCH = '/*',
  PROMOTIONS = '/promotions',
  BLOG = '/blog',
  HELP_CENTER = '/helpCenter',
}
